import { defineMessages } from 'react-intl-next';
export let NoticeMessage = /*#__PURE__*/function (NoticeMessage) {
  NoticeMessage["Delete"] = "Delete";
  NoticeMessage["Discard"] = "Discard";
  NoticeMessage["Change"] = "Change";
  NoticeMessage["Confirm"] = "Confirm";
  NoticeMessage["Submit"] = "Submit";
  NoticeMessage["Reopen"] = "Reopen";
  NoticeMessage["Close"] = "Close";
  NoticeMessage["Cancel"] = "Cancel";
  NoticeMessage["UpgradeNow"] = "UpgradeNow";
  NoticeMessage["MakeInternal"] = "MakeInternal";
  NoticeMessage["MakeExternal"] = "MakeExternal";
  NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
  NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
  NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
  NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
  NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
  NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
  NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
  NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
  NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
  NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
  NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
  NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
  NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
  NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
  NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
  NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
  NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
  NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
  return NoticeMessage;
}({});
export const IntlNoticeMessages = defineMessages({
  [NoticeMessage.Delete]: {
    id: 'ui-notices.confirmText.Delete',
    defaultMessage: 'Delete'
  },
  [NoticeMessage.Discard]: {
    id: 'ui-notices.confirmText.Discard',
    defaultMessage: 'Discard'
  },
  [NoticeMessage.Change]: {
    id: 'ui-notices.confirmText.Change',
    defaultMessage: 'Change'
  },
  [NoticeMessage.Confirm]: {
    id: 'ui-notices.confirmText.Confirm',
    defaultMessage: 'Confirm'
  },
  [NoticeMessage.Submit]: {
    id: 'ui-notices.confirmText.Submit',
    defaultMessage: 'Submit'
  },
  [NoticeMessage.Reopen]: {
    id: 'ui-notices.confirmText.Reopen',
    defaultMessage: 'Reopen'
  },
  [NoticeMessage.Close]: {
    id: 'ui-notices.confirmText.Close',
    defaultMessage: 'Close'
  },
  [NoticeMessage.Cancel]: {
    id: 'ui-notices.confirmText.Cancel',
    defaultMessage: 'Cancel'
  },
  [NoticeMessage.UpgradeNow]: {
    id: 'ui-notices.confirmText.UpgradeNow',
    defaultMessage: 'Upgrade Now'
  },
  [NoticeMessage.MakeInternal]: {
    id: 'ui-notices.confirmText.MakeInternal',
    defaultMessage: 'Make internal'
  },
  [NoticeMessage.MakeExternal]: {
    id: 'ui-notices.confirmText.MakeExternal',
    defaultMessage: 'Make external'
  },
  [NoticeMessage.DeleteFormTitle]: {
    id: 'ui-notices.title.DeleteFormTitle',
    defaultMessage: 'Confirm Deleting Form'
  },
  [NoticeMessage.DeleteFormMsg]: {
    id: 'ui-notices.msg.DeleteFormMsg',
    defaultMessage: 'Are you sure you want to delete the “{formName}” form? This cannot be undone.'
  },
  [NoticeMessage.ChangeFormAvailabilityTitle]: {
    id: 'ui-notices.title.ChangeFormAvailabilityTitle',
    defaultMessage: 'Confirm Changing Form Availability'
  },
  [NoticeMessage.ChangeFormToInternalHeader]: {
    id: 'ui-notices.title.ChangeFormInternalHeader',
    defaultMessage: 'Make form internal only and hide from customer'
  },
  [NoticeMessage.ChangeFormToInternalMsg]: {
    id: 'ui-notices.msg.ChangeFormInternalMsg',
    defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.'
  },
  [NoticeMessage.ChangeFormToExternalHeader]: {
    id: 'ui-notices.title.ChangeFormToExternalHeader',
    defaultMessage: 'Make form external and show to customer'
  },
  [NoticeMessage.ChangeFormToExternalMsg]: {
    id: 'ui-notices.msg.ChangeFormToExternalMsg',
    defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.'
  },
  [NoticeMessage.CancelEditFormTitle]: {
    id: 'ui-notices.title.CancelEditFormTitle',
    defaultMessage: 'Confirm Discarding Changes'
  },
  [NoticeMessage.CancelEditFormMsg]: {
    id: 'ui-notices.msg.CancelEditFormMsg',
    defaultMessage: 'There are changes to answers on the “{formName}” form that will be lost if you choose "Confirm". Are you sure you want to continue?'
  },
  [NoticeMessage.SubmitFormTitle]: {
    id: 'ui-notices.title.SubmitFormTitle',
    defaultMessage: 'Confirm Form Submission'
  },
  [NoticeMessage.SubmitFormMsg]: {
    id: 'ui-notices.msg.SubmitFormMsg',
    defaultMessage: 'Are you sure you want to submit this form ?'
  },
  [NoticeMessage.SubmitFormLockMsg]: {
    id: 'ui-notices.msg.SubmitFormLockMsg',
    defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.'
  },
  [NoticeMessage.ReopenFormTitle]: {
    id: 'ui-notices.title.ReopenFormTitle',
    defaultMessage: 'Confirm Reopening Form'
  },
  [NoticeMessage.ReopenFormMsg]: {
    id: 'ui-notices.msg.ReopenFormMsg',
    defaultMessage: 'Are you sure you want to reopen the submitted form for editing?'
  },
  [NoticeMessage.ErrorExplanations1]: {
    id: 'ui-notices.msg.ErrorExplanations1',
    defaultMessage: 'Please refer to our'
  },
  [NoticeMessage.ErrorExplanations2]: {
    id: 'ui-notices.msg.ErrorExplanations2',
    defaultMessage: 'Error Explanations'
  },
  [NoticeMessage.ErrorExplanations3]: {
    id: 'ui-notices.msg.ErrorExplanations3',
    defaultMessage: 'page for more details or contact'
  },
  [NoticeMessage.ErrorExplanations4]: {
    id: 'ui-notices.msg.ErrorExplanations4',
    defaultMessage: 'ThinkTilt Support'
  }
});